import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { SelectOption } from '@timechef/core/forms';
import { DishInformationEnum } from '../../../state/restaurants.models';

@Component({
  selector: 'app-select-dish-information',
  templateUrl: './select-dish-information.component.html',
  styleUrls: ['./select-dish-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectDishInformationComponent implements OnInit {
  @Input() currentDishInformation?: DishInformationEnum;

  @Input()
  filterOptions: SelectOption<DishInformationEnum>[] = [];

  filterCtrl = this.fb.control<DishInformationEnum | null>(null, [Validators.required]);

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    if (this.currentDishInformation) {
      this.filterCtrl.setValue(this.currentDishInformation);
    }
  }

  async validate() {
    if (this.filterCtrl.invalid) return;

    await this.modalCtrl.dismiss(this.filterCtrl.value);
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
